import React from 'react'

function Page404() {
  return (
    <div className='base-container404'>
            <div id="main404">
                <div className="container404">
                    <h1>Error 404</h1>
                    <h2>Üzgünüz :( Aradığınız sayfayı bulamadık.</h2>
                </div>
            </div>
    </div>
  )
}

export default Page404
